export default __webpack_public_path__ + "static/media/dallas.c7729e4b.png";